import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./context/PrivateRoute";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/auth/login";
import Dashboard from "./components/pages/dashboard";
import Layout from "./layout";
import SubCategory from "./components/pages/subCategory"
import PdfAdd from "./components/pages/addPdf";
import MainDashboard from "./components/pages/mainDashboard";
import Gallery from "./components/pages/gallery";
import AddGallery from "./components/pages/addgallery";
import Testimonials from "./components/pages/testmonials";
import Info from "./components/pages/info";
import Blog from "./components/pages/blog";
import AddBlog from "./components/pages/addblog";
import ContactUs from "./components/pages/contactus";
import Careers from "./components/pages/carriers";
import CareersDetails from "./components/pages/careersdetails";
import QuickReach from "./components/pages/quickreach";

const detectPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/android/i.test(userAgent)) {
    console.log("Opened on Android");
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !navigator.userAgent.includes('Mac')) {
    console.log("Opened on iOS");
  } else if (/windows/i.test(userAgent)) {
    console.log("Opened on Windows");
  } else {
    console.log("Opened on an Unknown Platform");
  }
};


function App() {

  useEffect(() => {
    detectPlatform();
  }, []);


  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/layout/*" element={<Layout />}>

            <Route path="mainDashboard" element={<MainDashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="Category" element={<SubCategory />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="addgallery" element={<AddGallery />} />        
            <Route path="Testimonials" element={<Testimonials />} />
            <Route path="Info" element={<Info />} />
            <Route path="Blog" element={<Blog />} />
            <Route path="addblog" element={<AddBlog />} />     
            <Route path="ContactUs" element={<ContactUs />} /> 
            <Route path="Careers" element={<Careers />} /> 
            <Route path="CareersDetails" element={<CareersDetails />} /> 
            <Route path="QuickReach" element={<QuickReach />} /> 

            
            
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
